/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { useToasts } from "@/stores";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function Toaster() {
  const toasts = useToasts();

  return (
    <ToastProvider>
      {toasts.map(function (toast) {
        const { id, title, message, type } = toast;
        return (
          <Toast key={id} variant={type === "error" ? "destructive" : "default"}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {message && <ToastDescription>{message}</ToastDescription>}
            </div>

            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport label="Application status toasts ({hotkey})" />
    </ToastProvider>
  );
}
